import { gold } from '@ant-design/colors';
import { WarningTwoTone } from '@ant-design/icons';
import { List } from 'antd';
import type { FC } from 'react';
import { ParamNameTitle } from '../../../components/ParamNameTitle.tsx';
import type { SelectedParameter } from '../../../hooks/store/useAppStore.ts';

export const ImportantInfos: FC<{
  selectedParams: SelectedParameter[];
  flipParamNames: boolean;
}> = ({ selectedParams, flipParamNames }) => {
  const paramsWithImportantInfos = selectedParams.filter(it => !!it.importantDescription);

  if (!paramsWithImportantInfos.length) {
    return null;
  }

  return (
    <div>
      <h3>Wichtige Informationen</h3>
      <List
        itemLayout="horizontal"
        dataSource={paramsWithImportantInfos}
        renderItem={param => (
          <List.Item>
            <List.Item.Meta
              avatar={<WarningTwoTone twoToneColor={gold[5]} style={{ fontSize: '16px' }} />}
              title={<ParamNameTitle shortName={param.shortName} longName={param.longName} flipParamNames={flipParamNames} />}
              description={<div style={{ whiteSpace: 'pre-wrap' }}>{param?.importantDescription}</div>}
            />
          </List.Item>
        )}
      />
    </div>
  );
};
